<template>
    <div id="sign-in-form-1">
        <div id="components-section" data-aos="fade-left">
            <div class="form-body">
                <p
                    class="title is-3"
                    style="margin-bottom: 0.5em; font-weight: 700"
                >
                    {{ $t("Verify Mobile Number") }}
                </p>
                <div>
                    <p>
                        <span>
                            {{ $t("Do you need to change phone number?") }}
                        </span>
                        <router-link to="/verify-data">{{
                            $t("Edit info")
                        }}</router-link>
                    </p>
                </div>
                <div
                    class="level"
                    style="margin-bottom: 0; height: 200px; display: flex"
                >
                    <div class="info">
                        <img src="@/assets/images/smartphone.svg" />
                        <p>
                            <span
                                :class="[
                                    { error: error },
                                    { success: !error && !loading },
                                ]"
                                >{{ $t(message) }}</span
                            >
                            <br />
                            <span class="mobile">+{{ phone }}</span>
                        </p>
                    </div>
                </div>

                <div
                    class="level"
                    style="height: 220px; margin-bottom: 0; display: flex"
                    v-if="phone"
                >
                    <div
                        class="level-item"
                        style="
                            flex-direction: column;
                            height: 100%;
                            width: 100%;
                        "
                    >
                        <b-field>
                            <input
                                type="text"
                                :class="{ error: error }"
                                :maxlength="1"
                                :has-counter="false"
                                ref="num1"
                                v-model="a"
                                @input="
                                    (e) => {
                                        if (
                                            !e.data ||
                                            ![
                                                0,
                                                1,
                                                2,
                                                3,
                                                4,
                                                5,
                                                6,
                                                7,
                                                8,
                                                9,
                                            ].includes(Number(e.data))
                                        )
                                            return (a = '');
                                        $refs.num2.focus();
                                    }
                                "
                                @focus="focused($event)"
                            />
                            <input
                                type="text"
                                :class="{ error: error }"
                                :maxlength="1"
                                :has-counter="false"
                                ref="num2"
                                v-model="b"
                                @keyup.delete="$refs.num1.focus()"
                                @input="
                                    (e) => {
                                        if (
                                            !e.data ||
                                            ![
                                                0,
                                                1,
                                                2,
                                                3,
                                                4,
                                                5,
                                                6,
                                                7,
                                                8,
                                                9,
                                            ].includes(Number(e.data))
                                        )
                                            return (b = '');
                                        $refs.num3.focus();
                                    }
                                "
                                @focus="focused($event)"
                            />
                            <input
                                type="text"
                                :class="{ error: error }"
                                :maxlength="1"
                                :has-counter="false"
                                ref="num3"
                                v-model="c"
                                @keyup.delete="$refs.num2.focus()"
                                @input="
                                    (e) => {
                                        if (
                                            !e.data ||
                                            ![
                                                0,
                                                1,
                                                2,
                                                3,
                                                4,
                                                5,
                                                6,
                                                7,
                                                8,
                                                9,
                                            ].includes(Number(e.data))
                                        )
                                            return (c = '');
                                        $refs.num4.focus();
                                    }
                                "
                                @focus="focused($event)"
                            />
                            <input
                                type="text"
                                :class="{ error: error }"
                                :maxlength="1"
                                :has-counter="false"
                                ref="num4"
                                v-model="d"
                                @keyup.delete="$refs.num3.focus()"
                                @input="
                                    (e) => {
                                        if (
                                            !e.data ||
                                            ![
                                                0,
                                                1,
                                                2,
                                                3,
                                                4,
                                                5,
                                                6,
                                                7,
                                                8,
                                                9,
                                            ].includes(Number(e.data))
                                        )
                                            return (d = '');
                                        $refs.num5.focus();
                                    }
                                "
                                @focus="focused($event)"
                            />
                            <input
                                type="text"
                                :class="{ error: error }"
                                :maxlength="1"
                                :has-counter="false"
                                ref="num5"
                                v-model="e"
                                @keyup.delete="$refs.num4.focus()"
                                @input="
                                    (e) => {
                                        if (
                                            !e.data ||
                                            ![
                                                0,
                                                1,
                                                2,
                                                3,
                                                4,
                                                5,
                                                6,
                                                7,
                                                8,
                                                9,
                                            ].includes(Number(e.data))
                                        )
                                            return (e = '');
                                        $refs.num6.focus();
                                    }
                                "
                                @focus="focused($event)"
                            />
                            <input
                                type="text"
                                :class="{ error: error }"
                                :maxlength="1"
                                :has-counter="false"
                                @keyup.delete="$refs.num5.focus()"
                                ref="num6"
                                v-model="f"
                                @input="
                                    (e) => {
                                        if (
                                            !e.data ||
                                            ![
                                                0,
                                                1,
                                                2,
                                                3,
                                                4,
                                                5,
                                                6,
                                                7,
                                                8,
                                                9,
                                            ].includes(Number(e.data))
                                        )
                                            return (f = '');
                                    }
                                "
                                @focus="focused($event)"
                            />
                        </b-field>

                        <Loading v-if="loading" />
                        <div v-if="error">
                            <p class="error">{{ $t(error) }}</p>
                        </div>

                        <p
                            class="form-gray pseudo-button"
                            style="margin-top: 20px"
                            @click="resendCode"
                        >
                            {{ $t("Resend the authentication number") }}
                        </p>
                    </div>
                </div>
                <hr />
                <div
                    style="
                        display: flex;
                        justify-content: space-between;
                        margin-top: 20px;
                    "
                >
                    <div>
                        <button
                            v-if="
                                this.$store.state.user &&
                                !this.$store.state.user.email_verified
                            "
                            class="auth-button"
                            @click="$router.push('/verify')"
                        >
                            {{ $t("Verify Email") }}
                        </button>
                    </div>
                    <button class="auth-button" @click="signOut">
                        {{ $t("Use another Account") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
    components: {
        Loading,
    },
    data() {
        return {
            a: "",
            b: "",
            c: "",
            d: "",
            e: "",
            f: "",
            loading: false,
            message: "Please enter the Code sent to",
            error: false,
        };
    },
    computed: {
        changeData() {
            const { a, b, c, d, e, f } = this;
            return {
                a,
                b,
                c,
                d,
                e,
                f,
            };
        },
        phone() {
            return this.$store.getters.getPhoneNumber;
        },
    },
    watch: {
        changeData: {
            immediate: true,
            handler(val) {
                this.error = false;
                this.verify();
            },
        },
    },
    methods: {
        signOut() {
            this.$store.dispatch("logout").then(() => {
                this.$router.push({
                    name: "homepage",
                });
            });
        },
        resendCode() {
            this.loading = true;
            this.$store
                .dispatch("RESEND_VERIFICAION_CODE")
                .then((res) => {
                    this.$buefy.toast.open({
                        message: this.$t("Code sent, please check your phone."),
                        type: "is-primary",
                    });
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                });
        },
        verify() {
            this.loading = true;
            let vcode = `${this.a}${this.b}${this.c}${this.d}${this.e}${this.f}`;
            if (
                this.a != "" &&
                this.b != "" &&
                this.c != "" &&
                this.d != "" &&
                this.e != "" &&
                this.f != ""
            ) {
                this.$store
                    .dispatch("verifyMobile", vcode)
                    .then((res) => {
                        this.$store.dispatch("verified");
                        this.$router.push({
                            name: "verify",
                        });
                    })
                    .catch((error) => {
                        this.a = "";
                        this.b = "";
                        this.c = "";
                        this.d = "";
                        this.e = "";
                        this.f = "";
                        setTimeout(() => {
                            this.error = error;
                            this.loading = false;
                        }, 0);
                    });
            } else {
                this.loading = false;
            }
        },
        focused(e) {
            e.target.select();
        },
        checkPromise(promise) {
            if (promise.isResolved) return promise;
            var isPending = true;
            var isRejected = false;
            var isFulfilled = false;
            var result = promise.then(
                function (v) {
                    isFulfilled = true;
                    isPending = false;
                    return v;
                },
                function (e) {
                    isRejected = true;
                    isPending = false;
                    throw e;
                }
            );

            result.isFulfilled = function () {
                return isFulfilled;
            };
            result.isPending = function () {
                return isPending;
            };
            result.isRejected = function () {
                return isRejected;
            };
            return result;
        },
    },
    mounted() {
        if (
            this.$store.state.user.token &&
            this.$store.state.user.mobile_verified
        ) {
            return this.$router.push("/");
        }
    },
};
</script>

<style lang="scss" scoped>
$error: #eb6174;

::v-deep {
    input {
        border: 2px solid #eee;
        box-shadow: none;
        border-radius: 5px !important;
        width: 50px;
        min-height: 70px;
        margin-right: 15px;
        text-align: center;
        font-size: 30px;
        padding: 0;
        font-weight: bold;

        @media screen and (max-width: 600px) {
            width: 19%;
            margin: 1%;
        }
    }
}

.error {
    color: $error;
    font-weight: bold;
    border-color: #eb6174 !important;
}

input.error {
    color: #000;
}

#sign-in-form-1 {
    background: no-repeat 0 50%;
    background-size: cover;
    // min-width: 100vw;
    min-height: 100vh;
    display: flex;
    justify-content: flex-end;
    padding: 10px 30px;

    @media screen and (max-width: 600px) {
        padding: 3px !important;
    }

    #components-section {
        width: 540px;

        @media screen and (max-width: 600px) {
            width: 100%;
        }

        z-index: 9999999;
    }

    .info {
        margin-top: 20px;
        display: flex;
        align-items: center;
        text-align: left;

        img {
            width: 60px;
            opacity: 0.5;
        }

        p {
            font-size: 14px;
            margin: 0 20px;

            span.mobile {
                font-weight: bold;
                font-size: 16px;
            }
        }
    }

    .form-body {
        border-radius: 5px;
        text-align: left;
        margin: 10px 0;
        background-color: white;
        width: 500px;
        padding: 40px 50px;
        width: 500px;

        @media screen and (max-width: 600px) {
            padding: 40px 10px;
            min-width: 100%;
            width: 100%;
        }

        @media screen and (max-width: 600px) {
            padding: 40px 10px;
            min-width: 100%;
            width: 100%;
        }

        .form-gray {
            color: #818181;
        }

        .control {
            margin-top: 20px;
        }

        .pseudo-button {
            position: relative;
            transition: 0.4s linear;
            margin-top: 50px;
            cursor: pointer;

            &::before {
                transition: 0.4s linear;
                position: absolute;
                content: "";
                display: inline-block;
                width: 100%;
                height: 1px;
                border-bottom: 1px solid #afa8f0;
                top: calc(100% + 5px);
                left: 0;
                transform-origin: center;
                transform: scaleX(0);
            }

            &:hover {
                color: #4c3cdd;

                &::before {
                    transform: scaleX(1) !important;
                }
            }
        }
    }
}
</style>
